import { render, staticRenderFns } from "./_submenu.vue?vue&type=template&id=6efd1dee&"
import script from "./_submenu.vue?vue&type=script&lang=js&"
export * from "./_submenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports